import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ErrorState {
  messageLocaleId?: string;
  exceptionError?: Error;
}

const initialState: ErrorState = {
  messageLocaleId: undefined,
  exceptionError: undefined,
};

const slice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setErrorMessageLocaleId: (
      state,
      action: PayloadAction<string>
    ): ErrorState => {
      return {
        ...state,
        messageLocaleId: action.payload,
      };
    },
    clearErrorMessageLocaleId: (state): ErrorState => {
      return {
        ...state,
        messageLocaleId: undefined,
      };
    },
    setExceptionError: (state, action: PayloadAction<Error>): ErrorState => {
      return {
        ...state,
        exceptionError: action.payload,
      };
    },
    clearErrorState: (): ErrorState => {
      return {
        messageLocaleId: undefined,
        exceptionError: undefined,
      };
    },
  },
});

export const errorReducer = slice.reducer;
export const {
  setErrorMessageLocaleId,
  clearErrorMessageLocaleId,
  setExceptionError,
  clearErrorState,
} = slice.actions;
